import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";
import Pagination from "../../Config/Pagination";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Link, useNavigate } from "react-router-dom";
import "../../Config/search.css";
import "../../Config/loader.css";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../../Config/loading.css";
import Swal from "sweetalert2";
import "../../Config/swal.css";
import { useLabelContext } from "../../../Context";
import { Footer } from "../footer/footer";

export default function Invoice() {
  const navigate = useNavigate();
  const { setID } = useLabelContext();

  const [productsData, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [productViewOBJ, setProductViewObj] = useState([]);
  const [productEditOBJ, setProductEditObj] = useState([]);

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_CRM_URL}invoice/GetInvoices`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        if (data.Status) {
          setProducts(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setProducts([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const showProductViewModal = (obj) => {
    setProductViewObj(obj);
  };

  const showProductEditModal = (obj) => {
    setProductEditObj(obj);
  };

  const handleEditInvoice = (item) => {
    console.log(item);
    setID(item.id);
  };

  const toggleActiveStatus = async (Id, currentStatus) => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}ActiveProduct`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ Id: Id, active: currentStatus ? 0 : 1 }),
      });

      const result = await response.json();

      if (result.Status) {
        // Update the local state to reflect the change
        setProducts((prevProducts) =>
          prevProducts.map((prod) =>
            prod.id === Id ? { ...prod, status: currentStatus ? 0 : 1 } : prod,
          ),
        );
        Swal.fire("Success", "Product status updated successfully", "success");
        window.location.reload();
      } else {
        Swal.fire("Error", "Failed to update product status", "error");
      }
    } catch (error) {
      console.error("Error updating product status:", error);
      Swal.fire(
        "Error",
        "An error occurred while updating product status",
        "error",
      );
    }
  };

  const formatDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const options = { day: "2-digit", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  const itemsPerPage = 10;

  // const filteredItems = productsData.filter((item) =>
  //   item.number.toString().includes(searchTerm.toLowerCase())
  // );

  const filteredItems = useMemo(() => {
    const results = productsData.filter((item) =>
      item.number.toString().includes(searchTerm.toLowerCase()),
    );

    setCurrentPage(1);

    return results;
  }, [productsData, searchTerm]);

  // Calculate indices for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleExcelDownload = () => {
    if (productsData.length === 0) {
      return;
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = productsData.map((item) => ({
      Number: `INV-${item.number}`,
      Amount: item.totalamount,
      "Total Tax": item.totaltax,
      Date: item.date ? formatDate(item.date) : "",
      Customer: item.cus_name,
      Project: item.proj_name,
      "Due Date": item.duedate ? formatDate(item.duedate) : "",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "productsData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "invoice.xlsx");
  };

  const handlePDFDownload = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Invoice",
      author: "Your Name",
      creator: "Your Application",
    });

    const tableData = [];

    // Add a header row
    const headers = [
      "Number",
      "Amount",
      "Total Tax",
      "Date",
      "Customer",
      "Project",
      "Due Date",
    ];
    tableData.push(headers);

    // Add rows
    productsData.forEach((item) => {
      const row = [];
      row.push(
        `INV-${item.number}`,
        item.totalamount,
        item.totaltax,
        item.date ? formatDate(item.date) : "",
        item.cus_name,
        item.proj_name,
        item.duedate ? formatDate(item.duedate) : "",
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("invoice.pdf");
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Base>
      <div className="">
        <div className="d-flex justify-content-between">
          <div className="page-title">
            <h4>Invoice</h4>
            <h6>Manage your Invoices</h6>
          </div>
          <div>
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li className="">
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="PDF"
                  onClick={handlePDFDownload}
                  className="btn btn-light btn-sm px-0"
                >
                  {/* <img src="assets/img/icons/pdf.svg" alt="PDF" /> */}
                  <i
                    className="fa-solid fa-file-pdf fa-2xl"
                    style={{ color: "#ff0000" }}
                  ></i>
                </a>
              </li>
              <li className="">
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Excel"
                  onClick={handleExcelDownload}
                  className="btn btn-light btn-sm "
                >
                  {/* <img src="assets/img/icons/excel.svg" alt="Excel" /> */}
                  <i
                    className="fa-solid fa-file-excel fa-2xl"
                    style={{ color: "#217346" }}
                  ></i>
                </a>
              </li>
              <li className="">
                <Link
                  className="btn btn btn-sm"
                  to="/add-invoice"
                  style={{ backgroundColor: "#1B2850" }}
                >
                  <i
                    className="fa-solid fa-plus"
                    style={{ color: "white" }}
                  ></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-4 my-2">
          <div className="input-group">
            <input
              type="text"
              name="search"
              placeholder="Search..."
              className="form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="input-group-text bg-primary" id="basic-addon1">
              <i className="fa-solid fa-magnifying-glass"></i>
            </span>
          </div>
        </div>
      </div>

      <div className=" mb-4">
        {loading ? (
          <div className="col-12 text-center">
            <div className="containers m-auto">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        ) : (
          currentItems && (
            <div className="row g-2">
              {currentItems.map((item, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4">
                  <div className="card mb-2 rounded-4">
                    <div className="card-body">
                      {/* Header */}
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div className="d-flex align-items-center gap-2">
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              width: "35px",
                              height: "35px",
                              borderRadius: "50%",
                              backgroundColor: "#1B2850",
                              color: "#fff",
                            }}
                          >
                            <i className="fa-solid fa-file-invoice"></i>
                          </div>

                          <div className="">
                            <h6
                              className="mb-0 fw-bold"
                              style={{ color: "#1B2850" }}
                            >
                              INV-{item.number}
                            </h6>{" "}
                          </div>
                        </div>

                        {/* Actions */}
                        <div className="dropdown">
                          {item.status === 1 ? (
                            <span className="badge badge-linesuccess me-2">
                              Draft
                            </span>
                          ) : (
                            <span className="badge badge-linedanger me-2">
                              Inactive
                            </span>
                          )}
                          <a
                            href="#"
                            className="text-dark"
                            data-bs-toggle="dropdown"
                            onClick={(e) => e.preventDefault()}
                          >
                            <i className="fa fa-ellipsis-v"></i>
                          </a>

                          <div className="dropdown-menu dropdown-menu-end">
                            <Link
                              className={`dropdown-item ${
                                item.status ? "" : "disabled"
                              }`}
                              to={`/view-invoice`}
                              state={{ invoice: item }}
                            >
                              <i className="fa-regular fa-eye text-primary me-2"></i>
                              View
                            </Link>

                            <Link
                              className={`dropdown-item ${
                                item.status ? "" : "disabled"
                              }`}
                              to={`/edit/invoice/${item.id}`}
                              onClick={() => handleEditInvoice(item)}
                            >
                              <i className="fa-regular fa-pen-to-square text-info me-2"></i>
                              Edit
                            </Link>
                          </div>
                        </div>
                      </div>

                      {/* Details */}
                      <div className="row g-3">
                        <div className="col-8">
                          <div className="d-flex align-items-center">
                            <i
                              className="fa-solid fa-building me-2"
                              style={{ color: "#1B2850" }}
                            ></i>
                            <span>{item.ClientName || "N/A"}</span>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <i
                              className="fa-solid fa-indian-rupee-sign me-2"
                              style={{ color: "#1B2850" }}
                            ></i>
                            <span>{item.total || "N/A"}</span>
                          </div>
                        </div>

                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <i
                              className="fa-solid fa-user me-2"
                              style={{ color: "#1B2850" }}
                            ></i>
                            <span title={item.AddedByName}>
                              {item.AddedByName?.length > 20
                                ? item.AddedByName.substring(0, 20) + "..."
                                : item.AddedByName || "N/A"}
                            </span>
                          </div>
                        </div>

                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <i
                              className="fa-solid fa-calendar-days me-2"
                              style={{ color: "#1B2850" }}
                            ></i>
                            <span>{formatDate(item.date)}</span>
                          </div>
                        </div>

                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <i
                              className="fa-solid fa-clock me-2"
                              style={{ color: "#1B2850" }}
                            ></i>
                            <span className="text-danger">
                              {formatDate(item.duedate)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )
        )}

        <div className="">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>

      <Footer></Footer>
    </Base>
  );
}
